import React, { Component } from "react";
import "./Dots.scss";

class Dots extends React.Component {
  determineDirection = (direction) => {
    if (direction) return `moving-${direction}`;
    return "";
  };
  render() {
    const direction = this.determineDirection(this.props.flowDirection);

    return (
      <div className={`top-sales-dots ${direction}`}>
        <div className={"dot s out left"}></div>
        <div className={"dot s first"}></div>
        <div className={"dot m first"}></div>
        <div className={"dot l"}></div>
        <div className={"dot m second"}></div>
        <div className={"dot s second"}></div>
        <div className={"dot s out right"}></div>
      </div>
    );
  }
}

export default Dots;
